// @flow
export type WidthConstraint = 'none' | 'full' | 'medium' | 'tight'

export const WIDTH_CONSTRAINTS = {
  NONE: 'none',
  FULL: 'full',
  MEDIUM: 'medium',
  TIGHT: 'tight',
}
